import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchCollection, fetchData } from '../../common/redux/collectionActions'
import { deliveryOccasions } from '../DataAnalytics/redux/dataAnalyticsActions'
import MyLoader from '../../common/components/MyLoader'
import { Grid, Row, Col } from 'react-bootstrap'
import { Loader } from 'react-loaders'
import ExploringMap from './ExploringMap'
import ExploreLock from './ExploreLock'
import KPIContainer from '../KPI/KPIContainer'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import axios from 'axios'

class ExploringDashboard extends Component {
    constructor(p) {
        super(p)

        this.state = {
            selectedLock: null,
            fromDate: moment().add(-1, 'months'),
            toDate: moment(),
            deliveryQty: 0,
            deliveryOccasionsQty: 0,
        }
    }

    componentDidMount() {
        axios.get(`${window.MYQLOCX_API}/subject/admin/deliveries/count`).then((r) => this.setState(r.data))

        if (!this.props.dataAnalytics.deliveryOccasions) this.props.deliveryOccasions({ fromDate: this.state.fromDate.toISOString(), toDate: this.state.toDate.toISOString() })
        if (!this.props.admin) this.props.fetchData(['admin', 'locks', 'deliveries'], { deliveries: { startDate: this.state.fromDate.toISOString(), endDate: this.state.toDate.toISOString() } })
        else if (this.props.deliveries.length === 0) this.props.fetchData(['deliveries'], { deliveries: { startDate: this.state.fromDate.toISOString(), endDate: this.state.toDate.toISOString() } })


        window.scrollTo(0, 0)
    }

    selectLock = (lockId, doScroll) => {
        if (this.state.selectedLock === lockId) {
            this.setState({ selectedLock: null })
        } else {
            this.setState({ selectedLock: lockId })

            if (doScroll !== false) document.getElementById(lockId).scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }

    changeDate = (date, targetName) => {
        this.setState({ [targetName]: moment(date) }, () => {
            this.props.deliveryOccasions({ fromDate: this.state.fromDate.toISOString(), toDate: this.state.toDate.toISOString() })
        })
    }

    render() {
        const { admin, locks = [], deliveries = [] } = this.props
        const { deliveryQty, deliveryOccasionsQty } = this.state

        return (
            <div>
                <MyLoader />

                <Grid fluid>
                    <Row>
                        <Col xs={12} md={1} lg={1}>&nbsp;</Col>

                        <Col xs={12} md={10} lg={10}>
                            {locks.length > 0 && deliveries.length > 0 && <ExploringMap locks={locks} deliveries={deliveries} selectLock={this.selectLock} />}
                        </Col>

                        <Col xs={12} md={1} lg={1}>&nbsp;</Col>
                    </Row>

                    <Row>
                        <Col xs={12}>
                        {admin && admin.user && locks && locks.length > 0 && <KPIContainer admin={admin} deliveryQty={deliveryQty} deliveryOccasionsQty={deliveryOccasionsQty} />}
                        </Col>
                    </Row>

                    <hr />

                    <Row>
                        <Col xs={12} md={3} lg={3}>&nbsp;</Col>

                        <Col xs={12} md={2} lg={2} style={{ textAlign: 'center' }}>
                            <div style={{ borderRadius: "4px", textAlign: "center", cursor: "text", width: "47%", display: "inline-block" }}>
                                <DatePicker
                                    locale="sv"
                                    dateFormat="dd/MM/yyyy"
                                    className="delivery-filter-container"
                                    style={{ cursor: "text" }}
                                    selected={this.state.fromDate.toDate()}
                                    onChange={(d) => this.changeDate(d, 'fromDate')}
                                />
                            </div>
                        </Col>

                        <Col xs={12} md={1} lg={1} style={{ textAlign: 'center' }}>
                            &nbsp;
                        </Col>

                        <Col xs={12} md={2} lg={2} style={{ textAlign: 'center' }}>
                            <div style={{ borderRadius: "4px", textAlign: "center", cursor: "text", width: "47%", display: "inline-block" }}>
                                <DatePicker
                                    locale="sv"
                                    dateFormat="dd/MM/yyyy"
                                    className="delivery-filter-container"
                                    style={{ cursor: "text" }}
                                    selected={this.state.toDate.toDate()}
                                    onChange={(d) => this.changeDate(d, 'toDate')}
                                />
                            </div>
                        </Col>

                        <Col xs={12} md={3} lg={3}>
                            {this.props.loading ? <Loader type="line-scale" color="#006e78" /> : null}
                        </Col>
                    </Row>

                    <br />

                    <Row>
                        <Col xs={12} md={1} lg={1}>&nbsp;</Col>

                        <Col xs={12} md={10} lg={10}>
                            {locks.filter((l) => l.sub_type === 'container' && !l.isCarrierDoor).map(lock => (
                                    <div key={lock._id} style={{ marginBottom: 30 }} onClick={() => this.selectLock(lock._id, false)}>
                                        <ExploreLock noDays={this.state.toDate.diff(this.state.fromDate, 'days')} deliveries={deliveries.filter(d => d.to_lock === lock._id)} lock={lock} selected={this.state.selectedLock === lock._id} />
                                    </div>
                            ))}
                        </Col>

                        <Col xs={12} md={1} lg={1}>&nbsp;</Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            &nbsp;
                        </Col>
                    </Row>
                </Grid>
            </div>
        )
    }
}

const mapProps = state => {
    return {
        admin: state.collectionData.admin,
        locks: state.collectionData.locks,
        deliveries: state.collectionData.deliveries,
        dataAnalytics: state.dataAnalytics,
        loading: state.loading.isLoading,
    }
}

const mapDispatch = dispatch => {
    return {
        fetchData: (...args) => dispatch(fetchData(...args)),
        deliveryOccasions: (...args) => dispatch(deliveryOccasions(...args))
    }
}

export default connect(mapProps, mapDispatch)(ExploringDashboard)